import type { VoidComponent } from "solid-js";
import { useTranslation } from "../../state/i18n";
import { formatNumber } from "../../utils/numberUtil.ts";

const FormatNumber: VoidComponent<{ value: number }> = (props) => {
  // It would be better to use the actual locale of the user, but unfortunately, we don't have it. The next best thing
  // is to base the formatting on the selected language
  const { currentLanguage } = useTranslation();

  return <>{formatNumber(currentLanguage(), props.value)}</>;
};

export default FormatNumber;
